import { Box, BoxProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export const HeaderStyle = styled(Box)`
  background-color: ${({ theme }) => theme.palette.grey[100]};
  display: flex;
  flex-direction: column;
  margin-bottom: 54px;

  ${({ theme }) => theme.breakpoints.up('md')} {
    flex-direction: row;
    align-items: center;
    height: 400px;
  }

  ${({ theme }) => theme.breakpoints.up('lg')} {
    margin-bottom: 62px;
  }
`;

export const Container = styled(Box)`
  flex-grow: 1;
  padding: 40px 24px 0px 24px;
  width: 100%;

  ${({ theme }) => theme.breakpoints.up('md')} {
    width: auto;
    padding: 0 24px;
  }

  ${({ theme }) => theme.breakpoints.up('lg')} {
    margin-left: calc((100vw - 1136px) / 2);
    padding: 0;
  }
`;

export const ImageWrapper = styled('div')`
  position: relative;
  height: 210px;
  width: 100%;

  ${({ theme }) => theme.breakpoints.up('md')} {
    width: 360px;
    height: 100%;
  }

  ${({ theme }) => theme.breakpoints.up('lg')} {
    width: 712px;
  }

  img {
    clip-path: polygon(0 75px, 100% 0, 100% 100%, 0% 100%);

    ${({ theme }) => theme.breakpoints.up('md')} {
      clip-path: polygon(210px 0, 100% 0, 100% 100%, 0% 100%);
    }
  }
`;
